export enum ConversationActionTypes {
    closeChoice = 'Close',
    nextMessageChoice = 'NextMessage',
    multiNode = 'MultiNode',
    recommendationChoice = 'Recommendation',
    freeTextEntryChoice = 'FreeTextEntry'
}
